
<v-menu offset-y max-width="40%">
    <template v-slot:activator="{ on, attrs }">
        <a
            v-bind="attrs"
            v-on="on"
        >
            <div class="ml-3">
                <v-icon color="red" size="22">mdi-alert</v-icon>
            </div>
        </a>
    </template>
    <div class="white">
        <div v-for="(message, index) in messages" :key = "index" class="v-flex">
            <div class="message-text" style="width: 220px">
                {{ formatDateTime (message.received) }}
            </div>
            <div class="message-text">
                {{ $t( message.errorId + ".message", parameters(message)) }}
            </div>
        </div>
    </div>
</v-menu>
